/**
 * <occasions-slider>
 *
 * Crossfades through occasion poster slides on a timer, with manual
 * arrow/dot navigation. Autoplay never starts for visitors who prefer
 * reduced motion — they still get full manual control.
 */
if (!customElements.get('occasions-slider')) {
  customElements.define(
    'occasions-slider',
    class OccasionsSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.occasions-slider__slide'));
        if (this.slides.length < 2) return;

        this.dots = Array.from(this.querySelectorAll('.occasions-slider__dot'));
        this.cta = this.querySelector('[data-occasions-cta]');
        this.current = 0;
        this.interval = parseInt(this.dataset.autoplayInterval, 10) || 5000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index, true));
        });

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());

        this.onMotionChange = () => (this.reducedMotion.matches ? this.stopAutoplay() : this.startAutoplay());
        this.reducedMotion.addEventListener('change', this.onMotionChange);

        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.reducedMotion?.removeEventListener('change', this.onMotionChange);
      }

      goTo(index, isManual) {
        const total = this.slides.length;
        const next = ((index % total) + total) % total;
        if (next === this.current) return;

        const leaving = this.slides[this.current];
        const entering = this.slides[next];

        leaving.classList.remove('is-active');
        leaving.setAttribute('aria-hidden', 'true');

        this.dots[this.current]?.classList.remove('is-active');

        this.current = next;
        entering.classList.add('is-active');
        entering.removeAttribute('aria-hidden');

        this.dots[this.current]?.classList.add('is-active');

        if (this.cta) {
          const link = entering.dataset.link;
          if (link) this.cta.setAttribute('href', link);
        }

        if (isManual) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      startAutoplay() {
        this.stopAutoplay();
        if (this.reducedMotion.matches) return;
        this.timer = setInterval(() => this.goTo(this.current + 1), this.interval);
      }

      stopAutoplay() {
        clearInterval(this.timer);
      }
    }
  );
}
